interface Events {
    [key: string]: Array<(payload: any) => void>;
}

export class EventAggregator {

    private events: Events = {};

    public subscribe(event: string, callback: (payload: any) => void) {
        if (!event) {
            throw new Error('Event channel/type was invalid');
        }
        if (!this.events.hasOwnProperty(event)) {
            this.events[event] = [];
        }
        this.events[event].push(callback);
    }

    public publish(event: string, payload?: any) {
        if (!this.events.hasOwnProperty(event)) {
            return;
        }
        this.events[event].forEach(callback => {
            callback.call(null, payload);
        });
    }
}